export default function EntityLocationsTableHeader() {
  return (
    <div className="border-1 border-gray flex border-b px-0 py-2 text-left">
      <div className="block w-[30%] font-bold">
        <h2 className="text-sm">Name</h2>
      </div>
      <div className="block w-[25%] font-bold">
        <h2 className="text-sm text-center">Location ID</h2>
      </div>
      <div className="block w-[45%] font-bold">
        <h2 className="text-sm text-center">Address</h2>
      </div>
    </div>
  );
}
